export enum IconType {
  MUI = 'mui',
  SSR = 'ssr',
  IMAGE = 'image',
}

export type IconEntry =
  | {
      type: IconType.SSR;
      component: (prefix?: string) => React.SVGProps<SVGElement>[];
      color?: string;
    }
  | {
      type: IconType.MUI;
      component: React.ElementType;
      color?: string;
    }
  | {
      type: IconType.IMAGE;
      src: string;
      color?: string;
    };
